import React, { useEffect, useState } from 'react';
import { Box, Flex, Grid, GridItem, IconButton, Image, useBreakpointValue } from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';
import Tropicana from '../components/Perso/Tropicana';
import Puls from '../components/Perso/Puls';
import Entregeeks from '../components/Perso/Entregeeks';
import NatureMorte from '../components/Perso/NatureMorte';
import Pickup from '../components/Perso/Pickup';
import Air from '../components/Perso/Air';

const medias = [
  { img: 'puls', component: Puls },
  { img: 'entregeeks', component: Entregeeks },
  { img: 'nature-morte', component: NatureMorte },
  { img: 'tropicana', component: Tropicana },
  { img: 'pickup', component: Pickup },
  { img: 'air', component: Air },
];

const UiUxInvoice: React.FC = () => {
  const [selectedSection, setSelectedSection] = useState<string>('');
  const [currentSection, setCurrentSection] = useState<any>();
  const isMobile = useBreakpointValue({ base: true, md: false });
  const isMd = useBreakpointValue({ base: true, md: true, lg: true, xl: false });
  const isSm = useBreakpointValue({ base: true, md: true, lg: false, xl: false });

  useEffect(() => {
    const media = medias.find(media => media.img === selectedSection);

    if (media) {
      setCurrentSection(media);
    }
  }, [selectedSection]);

  const closeCurrentSection = () => {
    setCurrentSection(null);
    setSelectedSection('');
  };

  return (
    <>
      {currentSection ? (
        <Grid templateColumns={isSm ? 'auto' : '1fr 3.2fr'}>
          {/* Colonne gauche */}
          <GridItem mt={isSm ? 'auto' : '60px'} minWidth={isMobile ? 'auto' : '500px'}>
            <currentSection.component />
            {!isSm && <Image style={{ position: 'absolute', bottom: '122px' }} src={`/medias/blabla.png`} alt={'blabla'} mb={4} />}
          </GridItem>

          <IconButton
            icon={<CloseIcon />}
            aria-label="Fermer"
            position="fixed"
            top="20px"
            right="20px"
            zIndex="modal"
            background="#FF0162"
            color="#EBE9D6"
            _hover={{ background: '#F87FADFF', color: '#EBE9D6' }}
            onClick={closeCurrentSection}
          />
          {!isSm ? (
            <Grid
              mt="-150px"
              h="calc(100vh + 7px)"
              overflowY="auto"
              overflowX="hidden"
              marginRight="-34px"
              marginLeft="10px"
              sx={{
                scrollbarWidth: 'none',
                '&::-webkit-scrollbar': {
                  display: 'none',
                },
              }}
              style={{ zIndex: 0, right: 0 }}
            >
              <Image width="full" src={`/medias/ux1/big/${currentSection.img}.png`} alt={currentSection.img} mb={4} />
            </Grid>
          ) : (
            <Grid mt={5}>
              <Image width="full" src={`/medias/ux1/big/${currentSection.img}.png`} alt={currentSection.img} mb={4} />
            </Grid>
          )}
        </Grid>
      ) : (
        <Grid templateColumns={isMd ? 'auto' : '1fr 3.2fr'} gap={6} mt="60px">
          <Flex display={isMd ? 'none' : 'flex'} justifyContent="center" direction="column" alignItems="center">
            <Image maxWidth="349px" src="/medias/ux1/text.png" alt="Text" />
            <Image maxWidth="349px" src="/medias/ux1/bot.png" alt="Bot" mt={10} />
          </Flex>
          <Grid templateColumns={isMobile ? 'auto' : isMd ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)'} gap={2} mt={isMobile ? 0 : -10} mr={isMobile ? 0 : 20} ml={isMobile ? 0 : 16}>
            {medias.map(media => (
              <Box key={media.img} onClick={() => setSelectedSection(media.img)} cursor="pointer" display="flex" justifyContent="center" alignItems="center" h={isMd ? '200px' : 'auto'}>
                <Image src={`/medias/ux1/miniatures/${media.img}.png`} maxHeight={isMd ? '200px' : 'auto'} alt={media.img} objectFit="contain" />
              </Box>
            ))}
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default UiUxInvoice;
